import React, { useContext, useEffect } from 'react';
import { useRef } from 'react';
import ExpandCollapse from '../../common/ExpandCollapse';
import GoUpParag from '../../common/GoUpParag';
import MatchBet from '../../common/MatchBet';
import MessageInfo from '../../common/MessageInfo';
import MainContext from '../../contexts/MainContext';
import { getStreamingId } from '../../data/streaming/streamingUtils';
import { classIf, getConfiguration, getMatchIdOrStageId, iconSportCssClass } from '../../data/utils';
import BetGeniusWidget from '../../data/widgets/BetGeniusWidget';
import BetradarWidget from '../../data/widgets/BetradarWidget';
import FlashbetWidget from '../../data/widgets/FlashbetWidget';
import StatsCoreWidget from '../../data/widgets/StatsCoreWidget';
import { bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, WidgetContext } from '../../data/widgets/WidgetContext';
import { ReactComponent as PinIcon } from '../../icons/pin.svg';
import { getLabel } from '../../InitData';
import ButtonsContainer from '../../prematch/prematch-home/ButtonsContainer';
import Streaming from '../common/Streaming';
import { FavoriteMarketsContext } from './LiveSuiteCompetition';
import Jersey from '../../common/jerseys/Jersey';
import StatsToggle from '../../common/StatsToggle';
import Img from '../../common/util/Img';
import ButtonsContainerAlt from '../../prematch/prematch-home/ButtonsContainerAlt';
import ButtonsContainerAltNew from '../../prematch/prematch-home/ButtonsContainerAltNew';

function byAggRanking(a, b) {
    if (a.idAggregata < 0) {
        return -1;
    } else if (b.idAggregata < 0) {
        return 1;
    }
    return 0;
}

function LiveCompetition(props) {
    const conf = getConfiguration();
    const mainContext = useContext(MainContext);
    const favoriteMarketsContext = React.useContext(FavoriteMarketsContext);
    const widgetContext = React.useContext(WidgetContext);
    const isBrWidgetS5 = brWidgetS5Enabled(props.sportRef,props.widgetType);
    const isBetgeniusWidget = bgWidgetEnabled(props.sportRef,props.widgetType,props.geniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType,props.lsportWidgetId);
    const flashbetWidgetUrl = getFlashbetWidgetUrl(props.widgetType);
    const streamingId = getStreamingId(props.streaming);
    const streamingInfo = props.streaming;
    const ctxs = useRef({}).current;
    ctxs.mainContext = mainContext;

    const gruppiScommessa = props.macrogruppo != null ? props.macrogruppo.aggregate : props.gruppiScommessa;
    let bets = props.bets;
    if (bets == null) {
        bets = [];
    }
    if (favoriteMarketsContext != null && favoriteMarketsContext.favoritesSelected) {
        bets = bets.filter(bet => {
            return favoriteMarketsContext.isMarketFavorite(props.sportRef, bet.id + '_' + bet.handicap) && bet.hasOdds;
        });
    } else {
        bets = bets.filter(bet => bet.hasOdds);
    }
    const betsList = bets.map((bet) => {
        const id = props.macrogruppo?.id ?? props.aggregata;
        const key = `${id}_${bet.uniqueId}`;
        return (
            <MatchBet key={key} {...bet} expanded={true} showFavoritesToggle={true} />
        );
    });

    // TODO usa un id come chiave
    const aggregateBtns = gruppiScommessa.sort(byAggRanking).map(function(betGroup, i) {
        function handleClick() {
            props.setAggregata(betGroup.idAggregata);
        }
        const selected = (favoriteMarketsContext == null || !favoriteMarketsContext.favoritesSelected) && betGroup.idAggregata === props.aggregata;
        return (
            <React.Fragment key={betGroup.idAggregata}>
                {favoriteMarketsContext != null && favoriteMarketsContext.showFavoritesForSport(props.sportRef) && i === 0 &&
                    <div className={"bg-bianco nero bordo-tondo elemento-macro pointer filter" + classIf(favoriteMarketsContext.favoritesSelected, 'icona-selezionata agg-selezionata')} onClick={() => favoriteMarketsContext.toggleFavorites()}>
                        {getLabel('favorite_markets')}
                        <PinIcon className="pin-icon ml-2"></PinIcon>
                    </div>    
                }
                <div data-id={`a-${betGroup.idAggregata}`} className={"bg-bianco nero bordo-tondo elemento-macro pointer filter" + classIf(selected, 'icona-selezionata agg-selezionata')} onClick={handleClick}>{betGroup.descrizione}</div>
            </React.Fragment>
        );
    });

    // const macrogruppiBtns =  props.macrogruppi && props.macrogruppi.map(function(mg, i) {
    //     function handleClick() {
    //         props.setMacrogruppo(mg);
    //     }
    //     return (
    //         <React.Fragment key={mg.id}>
    //             {favoriteMarketsContext != null && favoriteMarketsContext.showFavoritesForSport(props.sportRef) && i === 0 &&
    //                 <div className={"bordo-tondo elemento-macro pointer" + classIf(favoriteMarketsContext.favoritesSelected, 'icona-selezionata agg-selezionata')} onClick={() => favoriteMarketsContext.toggleFavorites()}>
    //                     {getLabel('favorite_markets')}
    //                     <PinIcon className="pin-icon ml-2"></PinIcon>
    //                 </div>    
    //             }
    //             <div className={"bordo-tondo elemento-macro pointer" + classIf(props.macrogruppo&&(props.macrogruppo.id === mg.id), 'icona-selezionata agg-selezionata')} onClick={handleClick}>{mg.descrizione}</div>
    //         </React.Fragment>
    //     );
    // });

    useEffect(function() {
        if (!props.isLive) {
            widgetContext.setWidget({
                widgetMatchId: getMatchIdOrStageId(props),
                widgetContainerId: '#collassaWidgetCompetition',
                widgetStartCollapsed: true
            });
        }

        if(props.isLive){
            if(conf.lstwc){
                mainContext.toggleStreaming(streamingInfo,streamingId,props.id,'betradar-widget')
            }
        }

        return function() {
            if(conf.lstwc){
                mainContext.setStreamingContainer('betradar-widget');
            }else{
                if(!props.isAgendaStreamingCompetition) {
                    mainContext.toggleStreaming(null,null,null);
                }
            }
            const settings = {
                isWidgetToggleable: true
            };
            if (!props.isLiveSuite) {
                Object.assign(settings, {
                    widgetMatchId: null
                });
            }
            widgetContext.setWidget(settings);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isLive, props.id]);

    function handleStreamingButton(container='betslip') {
        //mainContext.toggleStreamingGeniusFid(props.streaming.fid,'betslip');
        ctxs.mainContext.toggleStreaming(streamingInfo,streamingId,props.id, container);
    }

    function toggleStreamingWidget() {
        toggleWidgetMatch("#collassaWidgetCompetition");
        ctxs.mainContext.toggleStreaming(streamingInfo,streamingId,props.id);
    }

    function toggleWidgetMatch(containerId){
        if (widgetContext.widgetMatchId === props.id) {// se widget gia' aperto lo chiudo
                closeWidgetMatch();
            }else{// apro il widget
                const match = {
                    id: props.id,
                    roun: props.round,
                    geniusId: props.geniusId, 
                    lsportWidgetId: props.lsportWidgetId, 
                    widgetType: props.widgetType, 
                    sportRef: props.sportRef, 
                    sportId: props.sportId
                }
                openWidgetMatch(containerId, match)
            }
    }

    function closeWidgetMatch(){
        widgetContext.setWidget({
            widgetMatchId: null
        });
    }

    function openWidgetMatch(containerId, match){
        closeStreaming();
        widgetContext.setWidget({
            widgetGeniusId: match.geniusId,
            widgetLsportId: match.lsportWidgetId,
            widgetProviderType: match.widgetType,
            widgetMatchId: getMatchIdOrStageId(match),
            widgetContainerId: containerId
        });
    }

    function closeStreaming(){
        //mainContext.toggleStreamingGeniusFid(null);
        if(!conf.lstwc){
            mainContext.toggleStreaming(null,null,null);
        }
    }

    const icoSport = iconSportCssClass(props.sportRef, props.iconClass);
    const aggregateMaxNumOfRows = 3; //3

    return (
        <>
            {!props.isAgendaStreamingCompetition && 
                <>
                    <div className="titolo-blocco-sport titolo-con-data bg-nero bianco">
                        <div className="d-flex justify-content-between align-items-center w-100" >
                            {props.isLive &&
                                <div className={`img-fluid ico-sport mr-1 ${icoSport}`}></div>
                            }
                            <div className="d-flex flex-column">
                                <div className="d-flex items-center">
                                    {props.team2 &&
                                        <Jersey data={props.jerseys?.[0]} type={'home'} sportRef={props.sportRef} />
                                    }
                                    <p className="nome-partita-sport">{props.team1}</p>
                                </div>
                                {props.team2 &&
                                    <div className="d-flex items-center">
                                        <Jersey data={props.jerseys?.[1]} type={'away'} sportRef={props.sportRef} />
                                        <p className="nome-partita-sport">{props.team2}</p>
                                    </div>
                                }
                            </div>
                            <p className="data-orario-partita-sport d-flex justify-content-end align-items-center margine-sx">
                                {props.date} {props.time}
                                {streamingId &&
                                    <Img src="assets\img\sport\icone\tv-streaming.svg" alt="" className="liveTrackerWidget__streamIcon" onClick={toggleStreamingWidget} />
                                }
                                <StatsToggle className="fas fa-chart-bar stat-sel margine-sx-mezzo grigio pointer" match={props} />
                            </p>
                        </div>
                    </div>
                    <Streaming container="competition"/>
                    {widgetContext.widgetMatchId != null &&  widgetContext.widgetContainerId==='#collassaWidgetCompetition' &&
                            <div className={`widget-filtro-side margine-giu live-tracker-widget ${isBetgeniusWidget?'betgeniusWidget':''}`}>
                                {flashbetWidgetUrl ?
                                    <FlashbetWidget url={flashbetWidgetUrl}/>
                                    :
                                    isBetgeniusWidget ?
                                        <BetGeniusWidget url={getBetgeniustWidgetUrl(props.sportRef, props.categoryRef, props.tournamentRef)} />
                                    :
                                    isStatsCoreWidget ?
                                        <StatsCoreWidget />
                                    :
                                    <BetradarWidget id={"collassaWidgetCompetition"} matchId={props.id} className={`bordato-widget bg-nero ${isBrWidgetS5?'brWidgetS5':''} `} isBrWidgetS5={isBrWidgetS5} 
                                                    streamingComponent={<Streaming container="betradar-widget"/>} streamingContainer={mainContext.streamingContainer}
                                                    streaming={props.streaming} toggleStreaming={handleStreamingButton} mainContext={mainContext} />

                                }
                            </div>
                    }
                </>
            }
            {props.giocabilita !== undefined && !props.giocabilita ?
                <MessageInfo message={getLabel('general.giocabilita_chiusa')} />
                :
                <>
                    {((props.macrogruppi && props.macrogruppi.length > 1) || (gruppiScommessa && aggregateBtns.length > 1)) &&
                        <div className="macro-gruppi">
                            {/* {props.macrogruppi && props.macrogruppi.length > 1 &&
                                <ButtonsContainer id={props.macrogruppo?props.macrogruppo.id:null} buttons={macrogruppiBtns} aggregate={false} forceRows={true} />
                            } */}
                            {aggregateMaxNumOfRows <= 0 ?
                                gruppiScommessa && aggregateBtns.length > 1 &&
                                <ButtonsContainer id={props.aggregata} buttons={aggregateBtns} aggregate={true} forceRows={true} />
                            :
                            (aggregateBtns.length > 1 &&(
                                conf.iwh ? <div className='btn__container__aggregata'> <ButtonsContainerAltNew id={props.aggregata} buttons={aggregateBtns} aggregate={true} maxNumOfRows={aggregateMaxNumOfRows} scrollOffset={150} isLiveCompetition={true} /></div>
                                :
                                <ButtonsContainer id={props.aggregata} buttons={aggregateBtns} aggregate={true} maxNumOfRows={aggregateMaxNumOfRows} scrollOffset={150} isLiveCompetition={true}   />
                            )
                            )
                            }
                            
                        </div>
                    }
                    <div className="colonne-evento-live d-grid unaColonna">
                        {favoriteMarketsContext.favoritesSelected && betsList.length === 0 ?
                            <div className="text-center">{getLabel('favorite_markets.add_markets')}</div>
                            :
                            <>
                                <ExpandCollapse key={(props.macrogruppo && props.macrogruppo.id) || props.aggregata} />
                                <div className="colonne-evento-live d-grid dueC6olonne">
                                    {betsList}
                                </div>
                            </>
                        }
                    </div>
                    <GoUpParag/>
                </>
            }
        </>
    );
}

export default LiveCompetition;
